import { Table } from 'react-bootstrap';
import './Leaderboard.css';

import { errorMessages } from '../utilities/constants';
import PlaceHolder from '../components/PlaceHolder';
import { DatatableWrapper, TableBody, TableHeader } from 'react-bs-datatable';
import parse from 'html-react-parser';
import { useLeaderBoardContext } from '../context/LeaderboardContext';
import { useEffect, useState } from 'react';
import Dialog from '../components/Dialog';
import leaderboard from '../assets/icon/leaderboard.svg';
import LoadingBox from '../components/LoadingBox';

const Leaderboard = () => {
  const [leaderboardRaiData, setLeaderboardRaiData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);

  const { leaderboardData, isLoading, errorMessage } = useLeaderBoardContext();

  // Process data
  useEffect(() => {
    let modifiedRaiData: any[] = [];
    if (leaderboardData?.length > 0 && leaderboardData[0].LB_RAI) {
      leaderboardData[0].LB_RAI.forEach((row: any, index: number) => {
        Object.keys(row).forEach((key) => {
          if (key !== 'id' && key !== 'model_name') {
            row[key] = row[key] !== null ? Number(parseFloat(row[key]).toFixed(2)) : 0;
          }
        });
        modifiedRaiData[index] = row;
      });
      setLeaderboardRaiData(modifiedRaiData);
      setCurrentPage(1); // reset to page 1
    }
  }, [leaderboardData]);

  const leaderboardRaiHeaders = [
    { prop: 'model_name', title: 'Model', isSortable: true },
    { prop: 'toxicity', title: 'Toxicity', isSortable: true },
    { prop: 'perplexity', title: 'Perplexity', isSortable: true },
    { prop: 'relevance_score', title: 'Relevance Score', isSortable: true }
  ];

  // Pagination calculations
  const totalItems = leaderboardRaiData.length;
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedData = leaderboardRaiData.slice(startIndex, startIndex + rowsPerPage);

  // Handlers
  const handlePrev = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const handleNext = () => setCurrentPage((p) => Math.min(p + 1, totalPages));
  const handleRowsChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Error handling
  if (errorMessage) {
    if (errorMessage.message === 'UNAUTHORIZED' || errorMessage === 'UNAUTHORIZED')
      return <Dialog />;
    else return <PlaceHolder message={parse(errorMessages.serverError)} />;
  }

  if (isLoading) {
    return (
      <div
        style={{ height: '100vh' }}
        className="container-fluid d-flex justify-content-center align-items-center">
        {/* <h4 className="text-center">Loading...</h4> */}
        <LoadingBox />
      </div>
    );
  }

  return (
    <div className="leaderboard-container pt-4">
      {/* Header */}
      <div className="leaderboard-header mb-3">
        <h5 className="leaderboard-title d-flex align-items-center gap-2">
          <img src={leaderboard} alt="Leaderboard Icon" width={19.53} height={16.5} />
          Leaderboard
        </h5>
        <p className="leaderboard-description">
          Compare AI models based on latency, cost, context size, and safety to help select the most
          suitable model for your application.
        </p>
      </div>

      {/* Table */}
      <div className="leaderboard-table-container">
        <div className="leaderboard-table-wrapper">
          {paginatedData.length > 0 && (
            <DatatableWrapper body={paginatedData} headers={leaderboardRaiHeaders}>
              <Table className="unl-table mb-0">
                <TableHeader />
                <TableBody />
              </Table>
            </DatatableWrapper>
          )}
        </div>

        {/* Custom Pagination */}
        <div className="custom-pagination">
          <span className="total-text">
            Total: <span>{totalItems}</span>
          </span>

          <div className="page-controls">
            <button onClick={handlePrev} disabled={currentPage === 1}>
              &lt;
            </button>
            <span>
              {currentPage} of {totalPages}
            </span>
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              &gt;
            </button>
          </div>

          <div className="rows-selector">
            <span>Show per page:</span>
            <select value={rowsPerPage} onChange={handleRowsChange}>
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leaderboard;
